import { useEffect } from 'react';

import { useAuth } from '~modules/auth/model';

const LOGOUT_DELAY = 10000;

/**
 * Экран для отметки из приватного режима: опознать устройство в нем невозможно,
 * поэтому работа запрещена и сеанс завершается.
 */
export function IncognitoBlocked() {
	const { logout } = useAuth();

	useEffect(() => {
		const timer = setTimeout(() => logout(), LOGOUT_DELAY);
		return () => clearTimeout(timer);
	}, [logout]);

	return (
		<div className="session-page__blocked">
			<h2>Работа в приватном режиме запрещена</h2>
			<p>
				В режиме инкогнито устройство, с которого выполняется отметка, определить невозможно. Закройте приватное
				окно и войдите в обычном окне браузера.
			</p>
			<p>Сеанс будет завершен автоматически.</p>
			<button className="btn btn--primery" onClick={logout}>
				Выйти
			</button>
		</div>
	);
}
